<template>
  <v-card class="mx-auto">
    <v-list>
      <v-list-item v-if="globalSearchResults.length === 0">
        <v-list-item-subtitle>
          <span>「{{ globalSearchWord }}」に一致するグループは見つかりませんでした。</span>
        </v-list-item-subtitle>
      </v-list-item>
      <v-list-item
        :key="group.groupId"
        v-else
        v-for="group in globalSearchResults"
        @click="toGroupPage(group.groupId)"
      >
        <v-list-item-avatar>
          <v-img src="@/assets/グループ・メンバーの無料アイコン素材.png" />
        </v-list-item-avatar>

        <v-list-item-content>
          <v-list-item-title v-text="group.groupName" />
        </v-list-item-content>

        <v-list-item-content>
          <v-list-item-subtitle>
            <v-row
              align="center"
              justify="center"
            >
              <v-col>
                <v-icon small> mdi-account-group </v-icon>
                <span> {{ group.groupMembers.length }} </span>
              </v-col>
            </v-row>
          </v-list-item-subtitle>
        </v-list-item-content>

        <v-list-item-content>
          <v-list-item-subtitle v-text="group.groupRequirements" />
        </v-list-item-content>

        <v-list-item-action>
          <v-row v-if="group.isJoin">
            <v-btn
              color="primary"
              disabled
              icon
            >
              <v-icon> mdi-account-multiple-check </v-icon>
            </v-btn>
          </v-row>

          <v-row v-else>
            <v-tooltip bottom>
              <template v-slot:activator="{ attrs, on }">
                <v-btn
                  color="primary"
                  icon
                  v-bind="attrs"
                  v-on="on"
                >
                  <v-icon @click="apply(group)"> mdi-account-multiple-plus </v-icon>
                </v-btn>
              </template>
              <span> このグループに参加します </span>
            </v-tooltip>
          </v-row>
        </v-list-item-action>
      </v-list-item>
    </v-list>
  </v-card>
</template>

<script>
import { mapActions, mapGetters } from "vuex";

export default {
  computed: {
    ...mapGetters([
      "globalSearchWord",
      "loginUserId",
      "group/groups"
    ]),
    // 検索結果
    globalSearchResults() {
      const globalSearchResults = [];
      let rowData = this["group/groups"];
      if (!this["group/groups"]) {
        rowData = this.$store.state.group.groups
        if (!rowData) {
          alert("再検索を行います。");
          this.research();
        }
      }
      rowData.forEach(group => {
        group.isJoin = false;
        if (group.groupMembers) {
          if (this.globalSearchWord !== "") {
            if (group.groupName.toLowerCase().indexOf(this.globalSearchWord.toLowerCase()) > -1) {
              group.groupMembers.forEach(member => { if (member.userId === this.loginUserId) group.isJoin = true });
              globalSearchResults.push(group);
            }
          } else {
            group.groupMembers.forEach(member => { if (member.userId === this.loginUserId) group.isJoin = true });
            globalSearchResults.push(group);
          }
        }
      });
      return globalSearchResults;
    }
  },

  data: () => ({
    linkControl: true,
  }),

  methods: {
    ...mapActions([
      "joinTheGroup",
      "setLoading",
      "group/fetchGroups",
      "group/updateGroupMember"
    ]),
    // グループに参加します.
    apply(group) {
      this.linkControl = false;
      this["group/updateGroupMember"](group).then(returnValue => {
        if (returnValue !== false) {
          this.joinTheGroup(group);
        }
      })
      this.$emit("rerender");
    },
    research() {
      this.$emit("research");
    },
    // グループページに遷移します.
    toGroupPage(groupId) { if (this.linkControl) this.$router.push({ name: 'GroupDetail' , params: { "group_id": groupId } }) },
  },
};
</script>
